import React, { useState, useEffect } from 'react';
import LoginPageT from '../components/KozelBattleT/LoginPageT';
import GameT from '../components/KozelBattleT/GameT';
import { useAppDispatch } from '../stores/store';
import { generateKozelTUserId } from '../features/games/kozelBattleTSlice';

const KozelBattlePromo: React.FC = () => {
  const dispatch = useAppDispatch();
  const [isAuthenticated, setIsAuthenticated] = useState(
    () => sessionStorage.getItem('kozelBattleTAuth') === 'true'
  );

  useEffect(() => {
    if (isAuthenticated) {
      const existingId = localStorage.getItem('kozelBattleTUuid');
      if (!existingId) {
        dispatch(generateKozelTUserId());
      }
    }
  }, [isAuthenticated, dispatch]);

  if (!isAuthenticated) {
    return <LoginPageT onLoginSuccess={() => setIsAuthenticated(true)} />;
  }

  return <GameT />;
};

export default KozelBattlePromo;